import { useEffect, useState } from 'react';
import type { User } from '../api/types';
import { initials } from '../format';
import { avatarGradient } from './profile';

/**
 * A person's picture, or their initials on a colour taken from their id.
 * Falls back to the initials if the picture can't be loaded.
 */
export function Avatar({ user, size = 32, ring = false }: { user: Pick<User, 'id' | 'name' | 'email' | 'avatarUrl'>; size?: number; ring?: boolean }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [user.avatarUrl]);
  const style = { width: size, height: size, fontSize: Math.max(11, Math.round(size * 0.38)) };
  const cls = `avatar${ring ? ' ring' : ''}`;
  if (user.avatarUrl && !failed) {
    return <img className={`${cls} photo`} style={style} src={user.avatarUrl} alt="" onError={() => setFailed(true)} />;
  }
  return (
    <span className={cls} style={{ ...style, background: avatarGradient(user.id || user.email) }} aria-hidden>
      {initials(user.name, user.email)}
    </span>
  );
}
